import { ApiClientInterface } from './clients';

export class PremiumManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async sendCode(confirmationUuid: string): Promise<void> {
    return this.apiClient.post('send-code', { confirmationUuid });
  }

  public async confirmCode(confirmationUuid: string, smsCode: string): Promise<void> {
    return this.apiClient.post('confirm-code', { confirmationUuid, smsCode });
  }
}
